import React from 'react';

interface ModalFormProps {
    children?: React.ReactNode;
    onSubmit?: () => void | (() => void);
    className?: string;
}

const ModalForm = ({
    children,
    onSubmit = () => {},
    className = '',
    ...otherProps
}: ModalFormProps) => (
    <form
        className={`gds-modal__form ${className}`}
        onSubmit={onSubmit}
        {...otherProps}
    >
        {children}
    </form>
);

export default ModalForm;
